import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  Switch,
  Tooltip,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_LIST_STORE, API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { API_LIST_USER } from "api/user-mangement";
import ViewUser from "views/admin/Users/ViewUser/ViewStore";
import EditUser from "views/admin/Users/EditUser";
import { API_DELETE_USER } from "api/user-mangement";
import { CONSTANTS } from "config/constant";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import userplace from "../../../assets/img/orders/orderDetail/userplace.png";
import { API_ENABLE_DISABLE_USER } from "api/user-mangement";

const { Column } = Table;
const { TextArea } = Input;
const UsersTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_USER(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.totalUsers }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/lusers/edit/${record._id}`, { state: { data: record } });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    // navigate(`/admin/users/${record._id}`);
    navigate(`/admin/lusers/${record._id}`, { state: { data: record } });
  };

  const handleDelete = async (id) => {
    try {
      let respon = await API_DELETE_USER(id);
      message.success(respon?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting store:", error);
      message.error("Failed to delete");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };
  const handleSwitchChange = async (checked, record) => {
    try {
      const response = await API_ENABLE_DISABLE_USER(record._id);
      message.success(response?.message);
      fetchData();
    } catch (error) {
      console.error("Error toggling store status:", error);
      message.error("Failed to toggle store status");
    }
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  return (
    <div>
      <div className=" mb-6 mt-6 flex justify-between">
        <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        />

        <Link
          to={"/admin/lusers/create-user"}
          className="linear p-[4px 11px] flex h-11 w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-[14px] text-base font-semibold text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400  dark:text-white dark:active:bg-brand-200 "
        >
          + {t("Create User")}
        </Link>
      </div>
      <Table
        dataSource={data?.users}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id}
        scroll={{ x: true }}
      >

        <Column
          title={t("Profile Picture")}
          dataIndex="profile_image"
          key="profile_image"
          render={(text, record) => (
            <span>
              {
                <img
                  src={
                    record?.profile_image?.[0]?.file_url
                      ? CONSTANTS?.IMG_DIRECTORY +
                        record?.profile_image?.[0]?.file_url
                      : userplace
                  }
                  style={{
                    width: "4rem",
                    height: "4rem",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                  alt=""
                />
              }
            </span>
          )}
          width="9rem"
        />

        <Column
          title={t("Name")}
          dataIndex="first_name"
          key="first_name"
          width="9rem"
        />
        <Column title={t("Email")} dataIndex="email" key="email" width="9rem" />
        <Column
          title={t("Phone No")}
          dataIndex="phone_no"
          key="phone_no"
          width="9rem"
        />
            <Column
          title={t("Membership Plan")}
          dataIndex="phone_no"
          key="phone_no"
          width="9rem"
          render={(text, record) => (
            <span>
              {record?.current_membership_plan?.plan_title ? record?.current_membership_plan?.plan_title : "N/A"}
            </span>
          )}
        />
        <Column
          title={t("Address")}
          dataIndex="location"
          key="location"
          width="9rem"
          render={
            (text, record) =>
              record?.address?.map(
                (element, idx) =>
                  element?.is_selected === true ? (
                    <Tooltip title={element?.location}>
                      {element?.location?.length > 20
                        ? `${element?.location?.substring(0, 20)}...`
                        : element?.location}
                    </Tooltip>
                  ) : element?.location?.length > 20 ? (
                    `${element?.location?.substring(0, 20)}`
                  ) : (
                    element?.location
                  )
                // record?.address?.map((element,idx)=> (
                //  element?.is_selected === true ? <Tooltip title = {element?.location}>
                //     {
                //       element?.location?.length > 20 ? `${element?.location?.substring(0,20)}` : element?.location
                //     }
                //   </Tooltip> : null
                // )
              )
            //  record?.location ? (

            //   <Tooltip title={text}>
            //   {console.log(record,'iamrecord')}
            //     {record?.location?.length > 20
            //       ? `${record?.location?.substring(0, 20)}...`
            //       : record?.location}
            //   </Tooltip>
            // ) : record?.location?.length > 0 ? (
            //   record?.address?.[0]?.country + " " + record?.address?.[0]?.street
            // ) : (
            //   "--"
            // )
          }
        />
        <Column
          title={t("Actions")}
          key="actions"
          width="9rem"
          render={(text, record) => (
            // <Space size="middle">
            <div>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              ></Button>
              <Popconfirm
                title={t("Are you sure to delete this User?")}
                onConfirm={() => handleDelete(record?._id)}
                okText={t("Yes")}
                cancelText={t("No")}
              >
                <Button
                  type="danger"
                  icon={<DeleteOutlined />}
                  style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                ></Button>
              </Popconfirm>
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
            </div>
            // </Space>
          )}
        />
      </Table>
    </div>
  );
};

export default UsersTable;
